function removeBundleProducts(){
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      return response.json();
    }).then(data => {
      if(!data.status){
        const cartItems = data.items;
        if(cartItems.length > 0){
          const updates = {};
          cartItems.forEach(e=>{
            const property = e.properties.type;
            if(property){
              if(property == "Feelbar bundle"){
                updates[e.key] = 0;
              }
              if(property == "Free gift"){
                updates[e.key] = 0;
              }
            }
          });
          if(updates){
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({updates})
            })
            .then(response => {
              return response.json();
            })
            .then(data => {
              if(!data.status){
                const countLabel = document.querySelector("#cart-icon-bubble-label");
                countLabel ? countLabel.innerHTML = data.item_count : "";
              }
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
removeBundleProducts();

function addShippingProtectionOnStart(){
  const shippingOn = localStorage.getItem('shippingProtectionOn');
  const shippingProtectionVariantId = theme.cartInfo.protectionProductVariantId;
  const shippingProtectionId = theme.cartInfo.protectionProductId;
  
  if(!shippingProtectionId || !shippingProtectionVariantId) return;

  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => {
    return response.json();
  }).then(data => {
    if(!data.status){
      if(shippingProtectionId){
        let shippingHas = false;
        data.items.forEach(e=>{
          if(e.product_id == shippingProtectionId){
            shippingHas = true;
          }
        })
        if(!shippingHas){
          if(shippingOn){
            const item = JSON.parse(shippingOn);
            if (Date.now() > item.expiry) {
              addShippingProtectionToCart();
            }
          }else{
            addShippingProtectionToCart();
          }
        }
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  function addShippingProtectionToCart(){
    let formData = {
     'items': [{
      'id': shippingProtectionVariantId,
      'quantity': 1,
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
       return response.json();
    })
    .then(data=>{
      if(!data.status){
        const localdata = {
          value: 1,
          expiry: Date.now() + 1000 * 60 * 10 // expires in 10 minutes
        };
        localStorage.setItem('shippingProtectionOn', JSON.stringify(localdata));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}
// Initialize shipping protection on page load
document.addEventListener('DOMContentLoaded', function() {
  updateShippingProtection();
});

function updateShippingProtection(){
  const shippingProtectionTrigger = document.querySelector('#cart-shipping-protection-checkbox');
  if(!shippingProtectionTrigger) return;
  
  shippingProtectionTrigger.addEventListener('change',function(){
    const elem = this;
    
    if(this.checked){
      addShippingFromCart(this.dataset.id);
    }else{
      removeItemFromCart(this.dataset.id,0,elem);
    }
  });
  
  function addShippingFromCart(id){
    const checkoutButton = document.querySelector('.cart__checkout-button');
    
    if(checkoutButton){
      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
    }
    
    let formData = {
     'items': [{
      'id': id,
      'quantity': 1,
      }]
    };
    formData['sections_url'] = window.location.pathname;
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
       return response.json();
    })
    .then(data=>{
      if(!data.status){
        window.location.reload();
      }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));
    })
    .catch((error) => {
      elem.checked = false;
      console.error('Error:', error);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
    })
    .finally(() => {
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
      }
    });
  }
}

function freeShipCheck() {
    const confettiKey = 'confettiShown';
    const hasSuccess = document.querySelector('.free-shipping__progress--success');
    if (hasSuccess && !localStorage.getItem(confettiKey)) {
      triggerConfetti();
      localStorage.setItem(confettiKey, 'true');
    }
    if (!hasSuccess && localStorage.getItem(confettiKey)) {
      localStorage.removeItem(confettiKey);
    }
  }

function removeItemFromCart(id,quantity,elem = "",buttonEnable = false){
  const checkoutButton = document.querySelector('.cart__checkout-button');
  
  if(checkoutButton){
    checkoutButton.setAttribute('aria-disabled', true);
    checkoutButton.classList.add('loading');
  }
  
  let formData = JSON.stringify({
    id,
    quantity,
    sections_url: window.location.pathname
  });
  
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: formData
  })
  .then(response => {
     return response.json();
  })
  .then(data=>{
    if(!data.status){
      window.location.reload();
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));
    }
  })
  .catch((error) => {
    if(elem){
      elem.checked = true;
    }
    console.error('Error:', error);
    document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
  })
  .finally(() => {
    if(checkoutButton){
      checkoutButton.setAttribute('aria-disabled', false);
      checkoutButton.classList.remove('loading');
    }
  }); 
}

function removeBundleItem(){
  const removeTrigger = document.querySelectorAll('[bundle-item-remove]');
  if(!removeTrigger.length) return;
  const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
  const cart = document.querySelector('mini-cart');

  removeTrigger.forEach(e=>{
    e.addEventListener("click",function(){
      const id = this.dataset.id;
      let quantity = 0;
      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => {
        return response.json();
      }).then(data => {
        if(!data.status){
          const cartItems = data.items;
          if(cartItems.length > 0){
            cartItems.forEach(e=>{
              if(e.key == id){
                quantity = e.quantity - 1;
              }
            });
            removeItemFromCart(id,quantity,"",true);
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    })
  })
}

function removeGiftItem(){
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      return response.json();
    }).then(data => {
      if(!data.status){
        const cartItems = data.items;
        let bundleItems = 0;
        let freeGift = false;
        if(cartItems.length > 0){
          cartItems.forEach(e=>{
            const property = e.properties.type;
            if(property){
              if(property == "Feelbar bundle"){
                bundleItems = bundleItems + e.quantity;
              }
              if(property == "Free gift"){
                freeGift = e.key;
              }
            }
          });
          if(bundleItems < 4 && freeGift){
            removeItemFromCart(freeGift,0,"",true);
          }
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function bundleSubscription(){
  const subscriptionToggler = document.querySelector('mini-cart #cart-bundle__selling-plan-bar-input');
  if(subscriptionToggler){
    subscriptionToggler.addEventListener('change',function(){
      if(this.checked){
        this.closest('[bundle-selling-plan]')?.classList.add('active');
      }else{
        this.closest('[bundle-selling-plan]')?.classList.remove('active');
      }
    })
  }
}


let countdownDuration = 6 * 60 + 32; // 6 min 32 sec in seconds
let countdownTimeout;

function getESTHour() {
  const now = new Date();
  const utcOffset = now.getTimezoneOffset(); // in minutes
  const estOffset = 5 * 60; // UTC-5
  const diff = utcOffset - estOffset;
  now.setMinutes(now.getMinutes() + diff);
  return now.getHours();
}

function updateShippingMessages() {
  const estHour = getESTHour();
  const messageEls = document.querySelectorAll("#shipping-message");
  const subtextEls = document.querySelectorAll("#shipping-subtext");

  if (!messageEls.length || !subtextEls.length) return;

  const isSameDay = estHour < 12; // before 12 PM EST
  messageEls.forEach((el) => {
    el.textContent = isSameDay
      ? "Order within the next"
      : "Order in the next";
  });

  subtextEls.forEach((el) => {
    el.textContent = isSameDay
      ? "and it ships today"
      : "and it ships tomorrow!";
  });
}

function updateCountdownDisplays(remainingTime) {
  const countdownEls = document.querySelectorAll("#countdown");
  if (!countdownEls.length) return;

  const minutes = Math.floor(remainingTime / 60);
  const seconds = remainingTime % 60;
  const formattedTime =
    minutes + " min : " + (seconds < 10 ? "0" : "") + seconds + " sec";

  countdownEls.forEach((el) => {
    el.textContent = formattedTime;
  });
}

function startSharedCountdown() {
  if (countdownTimeout) clearTimeout(countdownTimeout);

  let startTime = localStorage.getItem("countdownStartTime");
  const now = Date.now();

  if (!startTime) {
    startTime = now;
    localStorage.setItem("countdownStartTime", startTime.toString());
  } else {
    startTime = parseInt(startTime, 10);
  }

  function tick() {
    const elapsed = Math.floor((Date.now() - startTime) / 1000);
    let remainingTime = countdownDuration - elapsed;

    if (remainingTime <= 0) {
      // Timer expired – reset
      countdownDuration = (Math.floor(Math.random() * 3) + 7) * 60; // 7–9 mins
      startTime = Date.now();
      localStorage.setItem("countdownStartTime", startTime.toString());
      updateShippingMessages();
      remainingTime = countdownDuration;
    }

    updateCountdownDisplays(remainingTime);
    countdownTimeout = setTimeout(tick, 1000);
  }

  updateShippingMessages();
  tick();
}

// Initialize timer on page load
// startSharedCountdown(); // Disabled - countdown timer removed from cart drawer

// Only update visuals (don't restart timer)
// ["cart:updated", "cartdrawer:opened", "ajaxProduct:added", "ajaxProduct:error", "discount:added"].forEach(event =>
//   document.addEventListener(event, () => {
//     updateShippingMessages();

//     // Sync display with stored time
//     const startTime = parseInt(localStorage.getItem("countdownStartTime"), 10);
//     const elapsed = Math.floor((Date.now() - startTime) / 1000);
//     const remainingTime = Math.max(countdownDuration - elapsed, 0);
//     updateCountdownDisplays(remainingTime);
//   })
// ); // Disabled - countdown timer removed from cart drawer



['cart:updated', 'cartdrawer:opened', 'ajaxProduct:added', 'ajaxProduct:error', 'discount:added'].forEach(event => document.addEventListener(event, e => {
  updateShippingProtection();
  removeBundleItem();
  removeGiftItem();
  bundleSubscription();
  freeShipCheck();
}));

function updateDiscount(){ 
  const discountBar = document.querySelector('.product [discount-bar-block]');
  // if(discountBar){
  //       alert('test');
    fetch(window.Shopify.routes.root + "?sections=discount-bar")
    .then(res => res.json())
    .then(data => {
       const html = new DOMParser().parseFromString(data['discount-bar'], 'text/html');
      if(discountBar){
       discountBar.innerHTML = html.querySelector('[discount-bar-block]').innerHTML;
      }
       const newDiscountBar = html.querySelector('[discount-bar-block]');

        if (newDiscountBar) {
          const milestoneEls = newDiscountBar.querySelectorAll('.discount-bar__milestone');
          const reachedMilestones = [];

          milestoneEls.forEach((milestoneEl) => {
            const milestoneValue = milestoneEl.getAttribute('data-milestone');
            const isActive = milestoneEl.classList.contains('active');
            const milestoneKey = `confetti_milestone_${milestoneValue}`;

            if (isActive) {
              reachedMilestones.push(milestoneKey);
              const alreadyTriggered = localStorage.getItem(milestoneKey);

              if (!alreadyTriggered) {
                // triggerConfetti();
                localStorage.setItem(milestoneKey, 'true');
              }
            } else {
              // Clean up localStorage if milestone is no longer reached
              localStorage.removeItem(milestoneKey);
            }
          });
        }
       
    });
  // }

if (document.querySelector('.mini-cart__inner .free-shipping__text--success')) {
    document.querySelector('.shipping-text-success').innerText = "FREE Shipping";
}
  else if(document.querySelector('.shipping-text-success')){
    document.querySelector('.shipping-text-success').innerText = "Calculated at checkout";
  } 
  
}

function triggerConfetti() {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 }
  });
}



document.addEventListener('ajaxProduct:added',updateDiscount);
document.addEventListener('cart:updated',updateDiscount);

function updateShippingText() {
    setTimeout(function() {
        const successText = document.querySelector('.mini-cart__inner .free-shipping__text--success');
        const shippingText = document.querySelector('.shipping-text-success');
        if (shippingText) {
            shippingText.innerText = successText ? "FREE Shipping" : "Calculated at checkout";
        }
    }, 3000);
}

document.addEventListener('DOMContentLoaded', updateShippingText);
window.addEventListener('load', updateShippingText);

  window.addEventListener('scroll', function() {
    const header = document.querySelector('sticky-header');
    const scrollY = window.scrollY;

    if (scrollY > 10) {
      header.classList.add('scrolleddd');
    } else {
      header.classList.remove('scrolleddd');
    }
  });
  
class cartSubscription extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.cart = document.querySelector('mini-cart');
    this.checkoutButton = cart.querySelector('button[name="checkout"]');
    if(!this.cart || !this.checkoutButton) return;
    this.selectBar = this.querySelector('#mini-cart-subscription-input');
    if(this.selectBar){
      const parent = this;
      this.selectBar.addEventListener('change',function(){
        if(this.checked){
          parent.changeSubscription(true);
        }else{
          parent.changeSubscription(false);
        }
      })
    }
  }

  async handleSubscription(key, quantity, selling_plan, isLastAction) {
    try {
      const cart = document.querySelector('mini-cart');
      const checkoutButton = cart.querySelector('button[name="checkout"]');
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', true);
        checkoutButton.classList.add('loading');
      }
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity,
          selling_plan,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        })
      });

      const state = await response.json();
      cart.renderContents(state);
      if(isLastAction) {
        if(checkoutButton){
          checkoutButton.setAttribute('aria-disabled', false);
          checkoutButton.classList.remove('loading');
        }
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        setTimeout(function(){
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response
            }
          }));
        },1000)
      }
      
    } catch (error) {
      console.error('Error updating cart:', error);
      const cart = document.querySelector('mini-cart');
      const checkoutButton = cart.querySelector('button[name="checkout"]');
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
      }
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }
  }

  async changeSubscription(enableSelling = false){
    const cart = document.querySelector('mini-cart');
    const lineItems = Array.from(cart.querySelectorAll('cart-items [data-cart-line-item]'));
    if(!lineItems.length) return;
    let items = [];
    for (let i = 0; i < lineItems.length; i++) {
      const line = lineItems[i];
      const isLast = i === lineItems.length - 1;
       await this.handleSubscription(lineItems[i].dataset.cartLineItem, Number(lineItems[i].dataset.quantity), enableSelling ? Number(lineItems[i].dataset.itemPlan) : null, isLast);
    }
  }
}

customElements.define("cart-subscription", cartSubscription);


class SubscriptionSelector extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-toggle]');
    this.dropdown = this.querySelector('[data-dropdown]');
    this.valueDisplay = this.querySelector('[data-value]');
    this.options = this.querySelectorAll('[data-option]');
    this.closingText = this.toggle.dataset.closingText ? this.toggle.dataset.closingText : "Close";
    this.openingText = this.toggle.dataset.openingText ? this.toggle.dataset.openingText : "Edit";

    this.toggle.addEventListener('click', () => this.handleToggle());
    
    this.options.forEach(option => {
      option.addEventListener('click', () => this.handleSelect(option));
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
  }

  handleToggle() {
    this.dropdown.classList.toggle('open');
    this.toggle.textContent = this.dropdown.classList.contains('open') ? this.closingText : this.openingText;
  }

  close() {
    this.dropdown.classList.remove('open');
    this.toggle.textContent = 'Edit';
  }

  handleSelect(option) {
    this.options.forEach(o => o.classList.remove('selected'));
    option.classList.add('selected');
    this.valueDisplay.textContent = option.textContent;
    this.close();

    this.changeCartItem(option.dataset.option,option.dataset.itemQuantity,option.dataset.value);

    this.dispatchEvent(new CustomEvent('change', {
      detail: { value: option.dataset.option, label: option.textContent }
    }));
  }

  changeCartItem(key, quantity, selling_plan) {
    const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
    const cart = document.querySelector('mini-cart');
    
    if(checkoutButton){
      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
    }
    
    let formData = JSON.stringify({
      id: key,
      quantity: quantity,
      selling_plan: selling_plan,
      sections: cart ? cart.getSectionsToRender().map((section) => section.id) : "",
      sections_url: window.location.pathname
    });
    
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: formData
    })
    .then(response => {
       return response.json();
    })
    .then(data=>{
      if(!data.status){
        if(!cart) {
          window.location = theme.routes.cart_url;
          return;
        }else{
          cart.renderContents(data);
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
    })
    .finally(() => {
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
      }
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }); 
  }

}

customElements.define('subscription-selector', SubscriptionSelector);



class lineItemSubscription extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.selectItem = this.querySelector('select');  
    if(!this.selectItem) return;
    this.selectItem.addEventListener('change',()=>{
      this.changeCartItem(this.selectItem.options[this.selectItem.selectedIndex].dataset.itemKey,this.selectItem.options[this.selectItem.selectedIndex].dataset.itemQuantity,this.selectItem.value);
    })
  }

  changeCartItem(key, quantity, selling_plan) {
    const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
    const cart = document.querySelector('mini-cart');
    
    if(checkoutButton){
      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
    }
    
    let formData = JSON.stringify({
      id: key,
      quantity: quantity,
      selling_plan: selling_plan,
      sections: cart ? cart.getSectionsToRender().map((section) => section.id) : "",
      sections_url: window.location.pathname
    });
    
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: formData
    })
    .then(response => {
       return response.json();
    })
    .then(data=>{
      if(!data.status){
        if(!cart) {
          window.location = theme.routes.cart_url;
          return;
        }else{
          cart.renderContents(data);
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
    })
    .finally(() => {
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
      }
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }); 
  }
}
customElements.define("line-item-subscription", lineItemSubscription);


